import React, { useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import { toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";


const PasswordReset = () => {
  const imagePath1 = `${process.env.PUBLIC_URL}/assets/images/auth/auth-img.png`
  const imagePath2 = `${process.env.PUBLIC_URL}/assets/images/BlueAsterAR.png`;
  const BaseUrl = process.env.REACT_APP_API;
  const [loading, setLoading] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const navigate = useNavigate();

  const handlePasswordReset = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    if (newPassword !== confirmPassword) {
      setPasswordError("Passwords do not match");
      setLoading(false);
      return;
    } 
  
    setPasswordError('');
  
  
   // Extract the token from the current URL
  const url = new URL(window.location.href);
  const queryString = url.search.substring(1); 
  const token = queryString;
  
    if (!token) {
      setLoading(false);
      return;
    }
  
    try {
      const response = await axios.post(`${BaseUrl}/verify_forgotpassword`, {
        newPassword,
        token
      });
     
      if (response.data.success) {
        toast.success("Password reset successfully.");
        navigate('/login');
      } else {
        toast.error(response.data.message || "Failed to reset password.");
      }
    } catch (error) {
      console.error("Error in handlePasswordReset:", error);
      toast.error("An error occurred. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <section className="auth forgot-password-page bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src={imagePath1} alt="Auth Illustration" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
               <Link to="/" className="mb-40 max-w-290-px">
                                  <img src={imagePath2} alt="" />
                                </Link>            
                                <div className="card-header">
                    <h4 className="card-title">Reset Password</h4><br></br>
                  </div>
                  <div className="card-body">
                    <form onSubmit={handlePasswordReset}>
                      <div className="mb-3">
                        <label htmlFor="newPassword" className="form-label">
                          New Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="newPassword"
                          value={newPassword}
                          onChange={(e) => setNewPassword(e.target.value)}
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="confirmPassword" className="form-label">
                          Confirm Password
                        </label>
                        <input
                          type="password"
                          className="form-control"
                          id="confirmPassword"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </div>
                      {passwordError && (
                        <div className="alert alert-danger" role="alert">
                          {passwordError}
                        </div>
                      )}
                      <button type="submit" className="btn btn-primary w-100">
                        Reset Password
                      </button>
                    </form>
                  </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PasswordReset;

